var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.5,
    fill: "#F7F7F7",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4516 10.8571H19.824L19.2047 10.0082C18.895 9.58367 18.4821 9 17.5015 9H13.8886C12.9079 9 12.5208 9.55714 12.1853 10.0082L11.566 10.8571H9.54839C8.69677 10.8571 8 11.5735 8 12.449V20.4082C8 21.2837 8.69677 22 9.54839 22H22.4516C23.3032 22 24 21.2837 24 20.4082V12.449C24 11.5735 23.3032 10.8571 22.4516 10.8571ZM13.0111 10.6449C13.295 10.2469 13.4499 10.0612 13.8886 10.0612H17.5015C17.966 10.0612 18.095 10.2469 18.3789 10.6449L19.3079 11.9184H22.4516C22.7355 11.9184 22.9677 12.1571 22.9677 12.449V20.4082C22.9677 20.7 22.7355 20.9388 22.4516 20.9388H9.54839C9.26452 20.9388 9.03226 20.7 9.03226 20.4082V12.449C9.03226 12.1571 9.26452 11.9184 9.54839 11.9184H12.0821L13.0111 10.6449Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6362 19.8331C17.8362 19.8331 19.6362 18.0456 19.6362 15.8609C19.6362 13.6762 17.8362 11.8887 15.6362 11.8887C13.4362 11.8887 11.6362 13.6762 11.6362 15.8609C11.6362 18.0456 13.4362 19.8331 15.6362 19.8331ZM15.6362 13.2127C17.1029 13.2127 18.3029 14.4044 18.3029 15.8609C18.3029 17.3174 17.1029 18.509 15.6362 18.509C14.1696 18.509 12.9696 17.3174 12.9696 15.8609C12.9696 14.4044 14.1696 13.2127 15.6362 13.2127Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3a755f76446ba3cc0c5d040d89ac8f7f.svg";
export { ForwardRef as ReactComponent };